import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import { easeInOut } from '../utils/curves';
import { largeDurationMs } from '../utils/durations';
import KeyframesMotion from './keyframes-motion';
var entranceMotions = {
  bottom: 'translate3d(0, calc(5% + 4px), 0)',
  left: 'translate3d(calc(-5% - 4px), 0, 0)',
  right: 'translate3d(calc(5% + 4px), 0, 0)',
  top: 'translate3d(0, calc(-5% - 4px), 0)'
};
var exitMotions = {
  bottom: 'translate3d(0, calc(-5% - 4px), 0)',
  left: 'translate3d(calc(5% + 4px), 0, 0)',
  right: 'translate3d(calc(-5% - 4px), 0, 0)',
  top: 'translate3d(0, calc(5% + 4px), 0)'
};
export var fadeInAnimation = function fadeInAnimation(movement) {
  return {
    from: _objectSpread({
      opacity: 0
    }, movement !== undefined && {
      transform: entranceMotions[movement]
    }),
    '50%': {
      opacity: 1
    },
    to: {
      transform: movement !== undefined ? 'none' : undefined
    }
  };
};
export var fadeOutAnimation = function fadeOutAnimation(movement) {
  return {
    from: {
      opacity: 1,
      transform: movement !== undefined ? 'translate3d(0, 0, 0)' : undefined
    },
    to: _objectSpread({
      opacity: 0
    }, movement !== undefined && {
      transform: exitMotions[movement]
    })
  };
};
/**
 * Props for controlling the behaviour of the FadeIn animation
 */

var FadeIn = function FadeIn(_ref) {
  var children = _ref.children,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? largeDurationMs : _ref$duration,
      entranceSlideDirection = _ref.entranceDirection,
      props = _objectWithoutProperties(_ref, ["children", "duration", "entranceDirection"]);

  return /*#__PURE__*/React.createElement(KeyframesMotion, _extends({
    duration: duration,
    enteringAnimation: fadeInAnimation(entranceSlideDirection),
    exitingAnimation: fadeOutAnimation(entranceSlideDirection),
    animationTimingFunction: function animationTimingFunction() {
      return easeInOut;
    }
  }, props), children);
};

export default FadeIn;